import { RootState } from '../../store';
import { IWellWaterSystemsMetrics } from '../../../types';
  
const selectWellWaterSystemsData = (state: RootState): IWellWaterSystemsMetrics => 
  state.wellWaterSystemMetrics.data ?? [];
const loading = (state: RootState) => state.wellWaterSystemMetrics.loading;

export const WellWaterSystemsMetricsSelector = {
  selectWellWaterSystemsData,
  loading,
};
